import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=fc6521ee&scoped=true&"
import script from "./Rules.vue?vue&type=script&lang=js&"
export * from "./Rules.vue?vue&type=script&lang=js&"
import style0 from "./Rules.vue?vue&type=style&index=0&id=fc6521ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6521ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc6521ee')) {
      api.createRecord('fc6521ee', component.options)
    } else {
      api.reload('fc6521ee', component.options)
    }
    module.hot.accept("./Rules.vue?vue&type=template&id=fc6521ee&scoped=true&", function () {
      api.rerender('fc6521ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/GlobalFilters/Rules.vue"
export default component.exports